import React from "react";
import './infoWindowView.css';
import moment from "moment";
import {EpochtoEpochTZ} from "../../../../shared/utils.js";

export const InfoWindowView=({lastPacketArriveAt,address})=>( <div className="info-window"><span
    className="time">Last updated at {moment(new Date(EpochtoEpochTZ(parseInt(lastPacketArriveAt),localStorage.getItem('timeZone')))).format('hh:mm:ss a')}</span>
    <div className="address-view">{address}</div>
</div>);